export const LinkTheme = {};
